// The 4 fixed-order section ids the UW contract validates `sections[]` against (§5).
export const RECON_SECTION_ID = {
    REVENUE_WORKING_CAPITAL: 'revenueWorkingCapital',
    BANK_ACCOUNTS_CASH_FLOW: 'bankAccountsCashFlow',
    DEBT_SANCTION_REPAYMENTS: 'debtSanctionRepayments',
    CAPITAL_RESERVES: 'capitalReserves',
} as const;

// The 3 drill-down-capable recon ids (§5 rule 4) — the only ids `drillDown.reconId` accepts.
export const RECON_DRILLDOWN_IDS = ['revenue', 'vendorPayments', 'newSanctions'] as const;

// The 11 recon ids the UW contract emits across all sections (§5).
export const RECON_ID = {
    REVENUE: 'revenue',
    VENDOR_PAYMENTS: 'vendorPayments',
    ACCOUNT_RECEIVABLES: 'accountReceivables',
    ACCOUNT_PAYABLES: 'accountPayables',
    BANK_BALANCE: 'bankBalance',
    CASH_BURN: 'cashBurn',
    EPF_STATUTORY_DUES: 'epfStatutoryDues',
    DEBT: 'debt',
    NEW_SANCTIONS: 'newSanctions',
    NET_WORTH: 'netWorth',
    EQUITY: 'equity',
} as const;

// Where a pill (FE-19) opens the drawer — D6. 'banking' and 'financials' show every section;
// 'gst' narrows display to the first section; 'debtDetails' narrows to the single Debt recon.
// This is a display-only filter over the one shared payload (selectSectionsForScope) — it never
// changes the request, so opening any pill never issues a second fetch (A-62).
export const RECON_SCOPE = {
    // The sidebar chip — every section, no narrowing.
    ALL: 'all',
    BANKING: 'banking',
    FINANCIALS: 'financials',
    GST: 'gst',
    DEBT_DETAILS: 'debtDetails',
} as const;

export type ReconScope = (typeof RECON_SCOPE)[keyof typeof RECON_SCOPE];

// Redux cache key for the page-load request (fys: null) — the server picks the latest 3
// audited FYs, and the response's own `fys` maps back to this key (no refetch on drawer open).
export const DEFAULT_FY_KEY = 'default';

export const fyKey = (fys: number[] | null | undefined): string =>
    !fys || fys.length === 0 ? DEFAULT_FY_KEY : [...fys].sort((a, b) => a - b).join(',');

export const drillDownKey = (reconId: string, fy: number): string => `${reconId}:${fy}`;
